/**
 * Detects if the user is viewing the site through the Betterment mobile app webview.
 * Checks the user agent string for Betterment mobile app identifiers.
 *
 * @returns true if the request is from a Betterment mobile app webview, false otherwise
 */
export function isMobileWebview(): boolean {
  const mobileWebviewRegex = /(?:Betterment|BMT)(?:\s+Internal|\s+Debug)?\/.*(?:iOS|iPhone|iPad|Android)/;
  return mobileWebviewRegex.test(navigator.userAgent);
}
